import React from "react";
import PropTypes from "prop-types";

import Avatar from "../../Avatar/Avatar";
import TextChannelItem from "./TextChannelItem";
import ImageChannelItem from "./ImageChannelItem";
import VideoChannelItem from "./VideoChannelItem";
import AttachmentChannelItem from "./AttachmentChannelItem";

import "../../User/User.scss";

const ChannelItem = (props) => {

    return (
        <div className="bg-smoke10 mb-4 mr-1">
            <div className="d-flex align-items-center p-2 border-bottom border-smoke">
                <div className="mr-2 user small">
                    <Avatar name={props.publisher} avatar={props.avatar} />
                </div>
                <div className="d-flex flex-column">
                    <h5 className="card-title mb-2">{props.publisher}</h5>
                    <h6 className="card-subtitle">{props.date}</h6>
                </div>

            </div>
            <div className="pl-2 pr-2 pt-3 pb-3">
                {props.entry.message && <TextChannelItem entry={props.entry} />}
                {props.entry.images && <ImageChannelItem entry={props.entry} images={props.images} />}
                {props.entry.video && <VideoChannelItem entry={props.entry} />}
            </div>
            <AttachmentChannelItem entry={props.entry} attachments={props.attachments} />
        </div>
    );
}

ChannelItem.propTypes = {
    entry: PropTypes.object,
    date: PropTypes.string,
    publisher: PropTypes.string,
    avatar: PropTypes.string,
    attachments: PropTypes.array,
    images: PropTypes.array
}

export default ChannelItem;